import moment from 'moment';
import {
  ConversationFilter,
  useGetDriverConversationCountsQuery,
  useGetDriverConversationsQuery,
} from '@store/rtk/driverChat';

export const useDriverConversationCounts = (skip: boolean, search: string) =>
  useGetDriverConversationCountsQuery(
    { serviceDate: moment().format('MM/DD/YYYY'), search },
    { skip, refetchOnMountOrArgChange: true }
  );

export const useDriverConversations = (
  filter: ConversationFilter,
  search: string,
  skip: boolean
) => {
  const { data, currentData, isLoading, isFetching, isError, refetch } =
    useGetDriverConversationsQuery(
      { filter, search },
      { skip, refetchOnMountOrArgChange: true }
    );

  return {
    conversations: data ?? [],
    isLoading: isLoading || (isFetching && currentData === undefined),
    isFetching,
    isError,
    refetch,
  };
};
